import kyonkyon from '../../../images/features/ambassador/profiles/kyonkyon_san.jpg';
import gooseBumps from '../../../images/features/ambassador/profiles/goose_bumps_san.jpg';
import kururi from '../../../images/features/ambassador/profiles/kururi_san.jpg';
import jun from '../../../images/features/ambassador/profiles/jun_san.jpg';
import taichiCohnosu from '../../../images/features/ambassador/profiles/taichi_cohnosu_san.jpg';
import chihilocal from '../../../images/features/ambassador/profiles/chihilocal_san.jpg';
import tessei from '../../../images/features/ambassador/profiles/tessei_san.jpg';
import berina from '../../../images/features/ambassador/profiles/berina_san.jpg';
import mishiko from '../../../images/features/ambassador/profiles/mishiko_san.jpg';
import yossie from '../../../images/features/ambassador/profiles/yossie_san.jpg';

export const PROFILES = [
  {
    image: kyonkyon,
    name: 'きょんきょん',
    hometown: '神奈川県出身',
    introduction:
      'はじめまして、旅する映像クリエイターのきょんきょんです！\n自分のカメラのスキルを活かして、日本全国で地域のお仕事ができて地域の人と繋がれるおてつたびの認知度をより高められるように頑張ります！',
    instagram: 'https://www.instagram.com/kyon_kyon0305/',
  },
  {
    image: gooseBumps,
    name: 'Goose Bumps',
    hometown: '（左）よしひろ　島根県出身\n（右）かずた　愛媛県出身',
    introduction:
      '現在、男2人で活動中のGooseBumpsです。今年1月より古民家をDIYしながらシェアハウスをしています。春にはトラックを購入し、夏までに車をキャンピングカーへ変貌させます。そして、日本一周の旅に出ます。僕らの旅✖おてつたびの活動で多くの人を巻き込んで、地域の魅力を盛大にアピールしていきます。〜個人に価値を、人生に鳥肌を〜というスローガンを掲げ全力疾走します。',
    twitter: 'https://twitter.com/endlessww',
    instagram: 'https://www.instagram.com/gb_yoshihiro/',
    youtube: 'https://www.youtube.com/channel/UCAZTuougyyvGb6h7bON7VRQ',
  },
  {
    image: kururi,
    name: 'KURURI',
    hometown: '愛知県出身',
    introduction:
      '私もおてつたびをきっかけに一歩踏み出せた一人。地域の魅力や仕事を知るワクワク感、なんとなく生きていたら生まれなかったヒトとの繋がり。パワーアップした自分と出逢えるおてつたびの魅力を素直な言葉で伝えます。',
    instagram: 'https://www.instagram.com/oasis_tap5/',
  },
  {
    image: jun,
    name: 'Jun',
    hometown: '埼玉県出身',
    introduction:
      '私はSNSで「少しでも多くの人に地域の魅力を知って欲しい」という思いで、地域や旅の発信を3年間続けてきました。その純粋な地域への気持ちを持って、精一杯この活動に取り組みたいと思います。',
    twitter: 'https://twitter.com/travel__hunt_ ',
    instagram: 'https://www.instagram.com/travel__hunt_/',
    youtube: 'https://www.youtube.com/channel/UC20mpZzbawLeW-uYgKt44OQ',
  },
  {
    image: taichiCohnosu,
    name: 'タイチコーノス',
    hometown: '千葉県出身',
    introduction:
      'ベッドタウンに育ってきた自分がコミュニティの暖かさに気づけたのはおてつたびのおかげだと思っています。アンバサダーの活動を通して、自分のような人をもっと増やしていけたらな〜と思っています！がんばるぞ！',
    twitter: ' https://twitter.com/t4sen',
    instagram: ' https://www.instagram.com/t4sen/',
  },
  {
    image: chihilocal,
    name: 'ちひろーかる',
    hometown: '山形県出身',
    introduction:
      'フリーランスデザイナーのちひろーかるです！おてつたびは3年ほど前に利用したことがあり、日本全国の地域の人たちとあたたかいつながりが持てる素敵なサービスだなと感じました。これから、おてつたびでまだ見ぬ土地を訪れて日本中に「ホーム」と呼べる場所をつくっていきたいです！',
    twitter: 'https://twitter.com/igaiga115',
    instagram: 'https://instagram.com/campgirl_chihiro',
  },
  {
    image: tessei,
    name: 'TESSEI',
    hometown: '滋賀県出身',
    introduction:
      '累計30か国以上への旅で得た知見、そして鍛え上げた筋肉を活かして、おてつたびの魅力を発信します！筋肉が必要な現場はお任せください！',
    twitter: 'https://twitter.com/onemorerepjapan',
    instagram: 'https://www.instagram.com/onemorerepjapan/',
  },
  {
    image: berina,
    name: 'べりな',
    hometown: '東京都出身',
    introduction:
      'はじめまして！18歳の渡辺利奈です。若さ、明るさ、元気さ、やる気は絶対に誰にも負けません！おてつたびにずっと応募したく、「高校卒業したら参加できる」とのことだったのでまだおてつたび経験はありませんが、所属しているNPO法人での経験や学校での文化祭実行委員長を務めた経験を活かしていきたいと思っています。おてつたびの魅力を全国へと広げるために、何事にも全力で、精一杯頑張ります。',
    twitter: ' https://twitter.com/watana_berina',
  },
  {
    image: mishiko,
    name: 'みしこ',
    hometown: '岡山県出身',
    introduction:
      '女子大生のみしこです！現在は大学を休学して、日本中の面白い生き方をする人に会いに行く旅に出ています。おてつたびアンバサダーとして、日本中の魅力的な人と土地を等身大でたっぷりと発信していきます！！',
    twitter: 'https://twitter.com/mishiko_ranran',
    instagram: 'https://www.instagram.com/mishiko_ranran/',
    youtube: 'https://www.youtube.com/channel/UCxIjzMnRCOQv77G1XDcpMkw/videos',
  },
  {
    image: yossie,
    name: 'よっしー',
    hometown: '神奈川県出身',
    introduction:
      '車で日本一周旅をしてます！！様々な地域で活動し、自身の撮った写真で皆さんにおてつたびの魅力やその地域の良さ、人との交流、ふれあいの大切さを伝え、日本の良さの再発見になればと思います。',
    instagram: 'https://www.instagram.com/yoshisu6/',
  },
];

export const TEXT_COLOR = '#333333';
